/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Today_StreakInputs */

const en_us2_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 week`);
	return /** @type {LocalizedString} */ (`${i?.weeks} weeks`)
	
};

const pt_br2_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas`)
	
};

const es_419_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas`)
	
};

const pt_pt2_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas`)
	
};

const fr_fr2_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semaine`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semaines`)
	
};

const de_de2_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 Woche`);
	return /** @type {LocalizedString} */ (`${i?.weeks} Wochen`)
	
};

const it_it2_today_streak = /** @type {(inputs: Today_StreakInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 settimana`);
	return /** @type {LocalizedString} */ (`${i?.weeks} settimane`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "1 week" |
* | * | "{weeks} weeks" |
*
* @param {Today_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_streak = /** @type {((inputs: Today_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_streak(inputs)
	if (locale === "es-419") return es_419_today_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_today_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_today_streak(inputs)
	if (locale === "de-DE") return de_de2_today_streak(inputs)
	if (locale === "it-IT") return it_it2_today_streak(inputs)
	return en_us2_today_streak(inputs)
});
export { today_streak as "today.streak" }